import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.css']
})
export class AccountingComponent implements OnInit {

  items: any = ["Template(30)","Template(31)","Template(32)","Template(33)","Template(34)","Template(35)"]
  id: any = 1;
  constructor(private router: Router ,private route: ActivatedRoute,private snackBar: MatSnackBar,) { }

  ngOnInit(): void {
  }

  newTemplate(){
    this.router.navigate(['new-template'])
  }

  editTemplate(id:any){
    this.router.navigate(['edit-template',id])
  }

  deleteTempalte(item:any){
    const index: number = this.items.indexOf(item);
    if (index !== -1) {
        this.items.splice(index, 1);
    }  

    this.snackBar.open('SUCCESS', 'Template was deleted', {
      duration: 5000,
      panelClass: ['white-snackbar']
    });
  }

  stopDefault(e: Event){
    e.stopPropagation()
  }



}
